/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeKwrResourceinfoData } from './moe-kwr-resourceinfo.data';
import { IMoeKwrResourceinfoProps } from './moe-kwr-resourceinfo.props.autogenerated';

export interface IMoeKwrResourceinfoViewProps extends IMoeKwrResourceinfoProps<IMoeKwrResourceinfoData> {}

/**
 *
 * MoeKwrResourceinfo component
 * @extends {React.PureComponent<IMoeKwrResourceinfoProps<IMoeKwrResourceinfoData>>}
 */
class MoeKwrResourceinfo extends React.PureComponent<IMoeKwrResourceinfoProps<IMoeKwrResourceinfoData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeKwrResourceinfo;
